import React, { FC, useCallback } from 'react';
import { useAuthContext } from '@raisin/cp-layout';
import { useFeatureFlag, isCSR } from '@raisin/cp-utils';
import { onCardClicked, onPaginationClicked } from 'eventsTracking';
import { AuthorizedProductCards, AuthorizedProductCardsProps } from './AuthorizedProductCards';
import {
  UnauthorizedProductCards,
  UnauthorizedProductCardsProps,
} from './UnauthorizedProductCards';
import { ProductCardsProps } from './types';
import { BankPageProductCards } from './BankPageProductCards';
import { getMarketingProductType } from '../../utils/getMarketingProductType';
import { RedirectProductCards } from './RedirectProductCards';

const ProductCards: FC<ProductCardsProps> = (props) => {
  const { isLoggedIn } = useAuthContext();
  const { variation } = useFeatureFlag();

  const cardClickHandler = useCallback(
    (productId: string) => {
      const product = props.dbs[productId];
      if (!product) {
        return;
      }
      onCardClicked({
        isLoggedIn,
        bankId: product.deposit_taking_bank.id,
        depositType: getMarketingProductType(product),
        productId,
      });
    },
    [props.dbs, isLoggedIn],
  );

  const paginationClickHandler = useCallback(() => {
    onPaginationClicked({ isLoggedIn });
  }, [isLoggedIn]);

  const isLinkUpdated = variation?.('b2cUpdateBankProductLink', false);
  const isWjisRedirectEnabled = variation?.('b2cUpdateWJISRedirect', false);

  if (props.errors && isCSR()) {
    props.errors.forEach((error) => console.info(error));
  }

  const contentProps: AuthorizedProductCardsProps | UnauthorizedProductCardsProps = {
    ...props,
    onProductClick: cardClickHandler,
    onPaginationClick: paginationClickHandler,
  };

  if (isLoggedIn) {
    return <AuthorizedProductCards {...contentProps} />;
  }

  if (isWjisRedirectEnabled) {
    return <RedirectProductCards {...contentProps} />;
  }

  if (isLinkUpdated) {
    return <BankPageProductCards {...contentProps} />;
  }

  return <UnauthorizedProductCards {...contentProps} />;
};

export default ProductCards;
